import React from "react";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import WizardFormStep from "../../components/WizardFormStep";
import FormFieldRow from "../components/FormFieldRow";
import FormInput, {
  SelectOption,
} from "../../../../../../toolkit/formInput";
import BaseSelect from "../../../../../../toolkit/baseSelectV2";
import * as yup from "yup";
import {
  createEinField,
  createEmailField,
  createPhoneField,
  createRequiredTextField,
  createSelectField,
} from "../../../../../../utils/validation/validationUtils";

export const organizationFormSchema = yup.object({
  organizationName: createRequiredTextField("Organization name"),
  legalOrganizationName: createRequiredTextField("Legal organization name"),
  organizationType: createSelectField("Please select an organization type"),
  organizationEINNumber: createEinField(),
  contactEmail: createEmailField("Contact email"),
  contactNumber: createPhoneField("Contact phone number"),
});

export const organizationTypeOptions: SelectOption[] = [
  { value: "NON_PROFIT", label: "Non-Profit" },
];

const OrganizationForm: React.FC = () => {
  return (
    <WizardFormStep
      title="Organization Details"
      subtitle="Please fill in the required details to set up your account."
      className={s.formContainer}
    >
      <FormFieldRow spacing="first">
        <FormInput
          name="organizationName"
          type="text"
          icon={"fa-regular fa-user"}
          placeholder="Organization Name"
        />
        <FormInput
          name="legalOrganizationName"
          type="text"
          icon={"fa-regular fa-user"}
          placeholder="Legal Name"
        />
      </FormFieldRow>
      <FormFieldRow>
        <BaseSelect
          name="organizationType"
          options={organizationTypeOptions}
          placeholder="Organization Type"
          defaultValue={organizationTypeOptions[0]}
        />
        <FormInput
          name="organizationEINNumber"
          type="text"
          placeholder="EIN (xx-xxxxxxx)"
        />
      </FormFieldRow>
      <FormFieldRow>
        <FormInput
          name="contactEmail"
          type="email"
          icon={"fa-regular fa-envelope"}
          placeholder="Contact email"
        />
        <FormInput
          name="contactNumber"
          type="tel"
          icon="fa-solid fa-phone"
          placeholder="Contact phone number"
        />
      </FormFieldRow>
    </WizardFormStep>
  );
};

export default withStyles(s)(OrganizationForm);
